import { render, staticRenderFns } from "./InfoTile.vue?vue&type=template&id=0efec157&scoped=true"
import script from "./InfoTile.vue?vue&type=script&lang=js"
export * from "./InfoTile.vue?vue&type=script&lang=js"
import style0 from "./InfoTile.vue?vue&type=style&index=0&id=0efec157&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efec157",
  null
  
)

export default component.exports